import axios from "axios";
import CryptoJS from "crypto-js";
import { _post, EXT, API_URL, headers } from "../../constants/config";
import { Buffer } from 'buffer';

export const getGeneratedQr = async (accessToken) => {
    let url       = `${API_URL}api/v1/get_generated_qr`;
    try {
        const response = await axios.post(url,{}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : null,
                'Access-Token' : `${accessToken}`, 
            }
        });
        return response.data;
    } catch(err) {
        console.log(err);
    }
}

export const generateQr = async (accessToken,usAccountId, usUuid) => {
    // Get the current date and time
    const currentDate = new Date();
    const currentDateTime = currentDate.toISOString().slice(0, 19).replace('T', ' ');

    // Generate SHA1 hash and truncate it to 8 characters
    const sha1Hash = CryptoJS.SHA1(currentDateTime).toString().substring(0, 8);

    // Generate a random number between 1000 and 9999
    const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;

    // Construct the key name without the underscore
    const randomId = sha1Hash + randomNumber;

    const publicId = `${usAccountId}_${usUuid}_${randomId}`;

    const encodedPublicId = Buffer.from(publicId, 'utf-8').toString('base64');
    
    let url       = `${API_URL}api/v1/generate_qr`;

    let data = JSON.stringify({
        "url": `${API_URL}public-profile/${encodedPublicId}`
    });

    try {
        const response = await axios.post(url, {data: data}, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization' : null,
              "Access-Token" : `${accessToken}`, 
            }
        });

        return response.data;
    } catch(err) {
        console.log(err);
    }
}